import { useOutDebtsReportQuery } from '../generated/graphql';
import { useGetProfile } from './useGetProfile';

export const useGetProfileAndDebtsReport = () => {
  const { hasToken, data: profileData, loading: profileLoading } = useGetProfile();

  const {
    data: outDebtsReportData,
    loading: outDebtsReportLoading,
  } = useOutDebtsReportQuery({ errorPolicy: 'ignore', skip: !hasToken });

  return {
    hasToken,
    profileData,
    profileLoading,
    outDebtsReportData,
    outDebtsReportLoading,
  };
};
